import { Component, OnInit } from '@angular/core';
import { AccountEndpoint } from '@app/core/endpoints/account-endpoint.service';
import { AccountService } from '@app/core/services/Common/account.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'sa-support-menu',
  templateUrl: './support-menu.component.html',
  styleUrls: ['./support-menu.component.css'],
  providers:[{provide: AccountService, useClass: AccountService},{provide:AccountEndpoint}]
})
export class SupportMenuComponent implements OnInit {

  title: string;
  closeBtnName: string;

  constructor(public bsModalRef: BsModalRef, public accountService : AccountService) { }

  ngOnInit() {

  }

  get isBroker(){
    return this.accountService.currentUser.entityType =='BROKER';
  }
}
